import { timezones } from "../../Static/Data/_Common/Timezones";

// IANA renamed these zones; browsers may report either spelling, and the
// timezones list uses one of them. Each pair is tried both ways.
const ZONE_ALIASES = [
  ["Asia/Calcutta", "Asia/Kolkata"],
  ["Asia/Katmandu", "Asia/Kathmandu"],
  ["Asia/Rangoon", "Asia/Yangon"],
  ["Asia/Saigon", "Asia/Ho_Chi_Minh"],
  ["America/Godthab", "America/Nuuk"],
  ["America/Buenos_Aires", "America/Argentina/Buenos_Aires"],
  ["Europe/Kiev", "Europe/Kyiv"],
  ["Pacific/Enderbury", "Pacific/Kanton"],
];

const getBrowserZoneName = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (error) {
    return "";
  }
};

// The browser's timezone as an entry of the timezones list. Matches the zone name
// first: matching only the current UTC offset picked the first zone with that offset
// (London became Europe/Belfast) and failed under daylight saving, where the
// browser's offset no longer equals the list's fixed offsetNumeric. The offset match
// is kept as the fallback for a zone the list does not have.
export const findTimezoneEntry = (zoneName, offsetMinutes, list = timezones) => {
  if (zoneName) {
    const candidates = [zoneName];
    ZONE_ALIASES.forEach(([a, b]) => {
      if (a === zoneName) candidates.push(b);
      if (b === zoneName) candidates.push(a);
    });
    const byName = list.find((item) => candidates.includes(item.name));
    if (byName) return byName;
  }
  return list.find((item) => item.offsetNumeric === offsetMinutes);
};

function FindLocalTimezone() {
  // Only the UTC offset is read here; no date is formatted or displayed.
  const offsetMinutes = new Date().getTimezoneOffset();
  return findTimezoneEntry(getBrowserZoneName(), offsetMinutes);
}

export default FindLocalTimezone;
